import React, { useState } from "react";
import DashBoard from "./components/common/layout/Index";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Customer, {
  modalOpertaionFlag
} from "./components/modules/customer/Index";
import CustomerUsers from "./components/modules/customer/users/Index";
import FinancialYear from "./components/modules/customer/financialYear/Index";
import { Operation, PageFor } from "./utils/Enum.types";
import PredefinedList from "./components/modules/customer/settings/predefinedList/List";
import AddCustomer from "./components/modules/customer/AddCustomer";
import AddUsers from "./components/modules/customer/users/AddUser";
import AssetConfiguration from "./components/modules/asset/configurations/AssetConfiguration";
import { SwConfigQueryType } from "./components/modules/asset/masters/items/configurations/queries/type";
import CustomerBillBookConfig from "./components/modules/customer/CustomerBillBookConfig";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ResetUserPassword from "./components/modules/asset/users/ResetUserPassword/ResetUserPassword";

const SysAdminRoutes = () => {
  const [modal, setModal] = useState(false);
  const [modalFlag, setModalFlag] = useState<modalOpertaionFlag>({
    flag: false,
    operation: Operation.CREATE
  });
  return (
    <div className="h100">
      <Router>
        <DashBoard>
          <Routes>
            <Route
              path="/*"
              element={
                <Routes>
                  <Route path="/" element={<Customer />} />
                  <Route
                    path="/:customerId/addcustomerdetails"
                    element={
                      <AddCustomer
                        setModalFlag={setModalFlag}
                        operation={Operation.CREATE}
                      />
                    }
                  />
                  <Route
                    path="/:customerId/addfinancialyear"
                    element={
                      <FinancialYear
                        operation={Operation.CREATE}
                        setModal={setModal}
                        steps
                      />
                    }
                  />
                  <Route
                    path="/:customerId/assigncustomerrights"
                    element={
                      <AssetConfiguration
                        setModalFlag={setModalFlag}
                        pageType={PageFor.VIEW}
                        queryType={SwConfigQueryType.EDUATE_COMPLETE_CONFIG}
                        steps
                      />
                    }
                  />
                  <Route
                    path="/:customerId/adduserdetails"
                    element={
                      <AddUsers
                        setModalFlag={setModalFlag}
                        operation={Operation.CREATE}
                        steps
                      />
                    }
                  />
                </Routes>
              }
            />

            <Route path="/settingsdashbord" element={<PredefinedList />} />
            <Route path="/:customerId/customer" element={<Customer />} />
            <Route
              path="/:customerId/financialYear"
              element={
                <FinancialYear
                  operation={Operation.CREATE}
                  setModal={setModal}
                  steps={false}
                />
              }
            />
             <Route
              path="/:customerId/resetuserpassword"
              element={
                <ResetUserPassword eduateSysAdmin={true} />
              }
            />

            <Route
              path="/:customerId/customerBillBook"
              element={<CustomerBillBookConfig />}
            />

            <Route
              path="/:customerId/customer/users"
              element={
                <CustomerUsers
                  setModalFlag={setModalFlag}
                  pageType={PageFor.GENERAL}
                />
              }
            />
          </Routes>
        </DashBoard>
      </Router>
    </div>
  );
};

export default SysAdminRoutes;
